import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "row col-md-7" }
const _hoisted_3 = { class: "el-input-group" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "row col-md-7" }
const _hoisted_7 = { class: "el-input-group" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "row col-md-7" }
const _hoisted_11 = { class: "el-input-group" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "row col-md-7" }
const _hoisted_15 = { class: "el-input-group" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "row col-md-7" }
const _hoisted_19 = { class: "el-input-group" }
const _hoisted_20 = { class: "col-md-9" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = { class: "row col-md-7" }
const _hoisted_23 = { class: "el-input-group" }
const _hoisted_24 = {
  key: 1,
  class: "btn btn-loading",
  disabled: ""
}
const _hoisted_25 = { class: "page-content-info d-flex align-items-center justify-content-end" }
const _hoisted_26 = { class: "me-3 mb-0" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { style: {"color":"red"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[18] || (_cache[18] = _createElementVNode("h2", null, "Получить предварительный расчет загруженных ДО", -1)),
    _cache[19] || (_cache[19] = _createElementVNode("p", null, "Нужно выбирать бины или населенный пункт. Расчетный месяц и год выбрать нужно обязательно", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            for: "timesheetType",
            class: "form-label col-md-3"
          }, "Тип табеля", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_multiselect, {
                modelValue: _ctx.timesheetType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timesheetType) = $event)),
                options: _ctx.timesheetTypeList,
                searchable: true,
                closeOnSelect: true,
                "custom-label": _ctx.formattedTimesheetTypeLabel,
                placeholder: "Выберите тип табеля",
                multiple: false,
                "clear-on-select": true
              }, null, 8, ["modelValue", "options", "custom-label"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            for: "katoCode",
            class: "form-label col-md-3"
          }, "Населенный пункт", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_multiselect, {
                modelValue: _ctx.kato,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kato) = $event)),
                options: _ctx.katoList,
                searchable: true,
                closeOnSelect: true,
                "custom-label": _ctx.formattedKatoLabel,
                placeholder: "Выберите Като",
                multiple: false,
                "clear-on-select": true
              }, null, 8, ["modelValue", "options", "custom-label"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[12] || (_cache[12] = _createElementVNode("label", {
            for: "binList",
            class: "form-label col-md-3"
          }, "Список БИНов (пишите через запятую или один за другим)", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("textarea", {
                id: "binList",
                cols: "30",
                rows: "10",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.binList) = $event)),
                placeholder: "1234567, 1234567, ...\nили\n1234567\n1234567\n..."
              }, null, 512), [
                [_vModelText, _ctx.binList]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[13] || (_cache[13] = _createElementVNode("label", {
            for: "accountingMonth",
            class: "form-label col-md-3"
          }, "Расчетный месяц", -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "1",
                max: "12",
                step: "1",
                class: "form-control",
                id: "accountingMonth",
                required: "",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accountingMonth) = $event))
              }, null, 512), [
                [_vModelText, _ctx.accountingMonth]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[14] || (_cache[14] = _createElementVNode("label", {
            for: "accountingYear",
            class: "form-label col-md-3"
          }, "Расчетный год", -1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "2024",
                step: "1",
                class: "form-control",
                id: "accountingYear",
                required: "",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.accountingYear) = $event))
              }, null, 512), [
                [_vModelText, _ctx.accountingYear]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fetchPreCalculation && _ctx.fetchPreCalculation(...args)))
          }, "Поиск"),
          (!_ctx.isPreCalculationLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-warning",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearSearchParam()))
              }, "Сбросить фильтр"))
            : (_openBlock(), _createElementBlock("button", _hoisted_24, "Загрузка")),
          _createElementVNode("button", {
            class: "btn btn-info",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fetchRunPreCalculationAmount && _ctx.fetchRunPreCalculationAmount(...args)))
          }, "Запустить предварительный расчет по выбранному фильтру")
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("label", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.onlyWithoutPdf) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.onlyWithoutPdf]
          ]),
          _cache[15] || (_cache[15] = _createTextVNode(" Только без PDF ")),
          (_ctx.kindergartenDetailResponse.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "(без PDF: " + _toDisplayString(_ctx.withoutPdfCount) + " из " + _toDisplayString(_ctx.kindergartenDetailResponse.length) + ")", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          disabled: (_ctx.kindergartenDetailResponse.length === 0) || _ctx.isDownloading,
          class: "btn btn-info align-items-center justify-content-end",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadGeneratedPreCalculationTimesheetList()))
        }, [
          (_ctx.isDownloading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[16] || (_cache[16] = _createElementVNode("span", {
                  class: "spinner-border spinner-border-sm me-2",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1)),
                _cache[17] || (_cache[17] = _createTextVNode("Формируется файл... "))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Выгрузить результат по фильтру")
              ], 64))
        ], 8, _hoisted_28)
      ])
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "number",
          label: "№"
        }),
        _createVNode(_component_el_table_column, { label: "Текст ошибки" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_29, _toDisplayString(scope.row.errorText), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "PDF" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.pdfStatusClass(scope.row.pdfStatus))
            }, _toDisplayString(_ctx.pdfStatusLabel(scope.row.pdfStatus)), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "bin",
          label: "БИН"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Название ДО"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lmsId",
          label: "LMS ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "katoNameRu",
          label: "Населенный пункт"
        }),
        _createVNode(_component_el_table_column, { label: "Предварительный расчет ФЦ с перерасчет" }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", {
              class: _normalizeClass({
            'text-danger': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) > 1000,
            'text-warning': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) < 1000 && Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) > 0,
            'text-success': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) == 0,
            })
            }, _toDisplayString(scope.row.totalSumFc), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Расчет LMS с перерасчет" }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", {
              class: _normalizeClass({
            'text-danger': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) > 1000,
            'text-warning': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) < 1000 && Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) > 0,
            'text-success': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) == 0,
            })
            }, _toDisplayString(scope.row.totalSumLms), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Предварительный расчет ФЦ без перерасчет",
          prop: "sumFc"
        }),
        _createVNode(_component_el_table_column, {
          label: "Расчет LMS без перерасчет",
          prop: "sumLms"
        }),
        _createVNode(_component_el_table_column, {
          label: "Лимит",
          prop: "limitFc"
        }),
        _createVNode(_component_el_table_column, {
          label: "Сумма перерасчета LMS",
          prop: "recalculationLms"
        }),
        _createVNode(_component_el_table_column, {
          label: "Сумма перерасчета ФЦ",
          prop: "recalculationFc"
        }),
        _createVNode(_component_el_table_column, {
          label: "Кол-во по проектной мощности",
          prop: "childrenCapacity"
        }),
        _createVNode(_component_el_table_column, {
          label: "Время последнего расчёта",
          prop: "lastCalculationDate"
        }),
        _createVNode(_component_el_table_column, {
          label: "LMS Document Id",
          prop: "lmsDocumentId"
        }),
        _createVNode(_component_el_table_column, {
          label: "Кол-во записей",
          prop: "timesheetCount"
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}